(function(){
    'use strict';

    angular
    .module('appback')
    .controller('HojaController', HojaController)
 
    HojaController.$inject = ["$scope","HojaService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce","Upload"];
              
    function HojaController($scope,HojaService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce,Upload)
    {                         
        var vm = this;
        vm.tabActive = 'hojaprod';
        console.log("hojacontroller",$scope);
        const currentDate = new Date();
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1; // Add 1 as months are zero-based
        const year = currentDate.getFullYear();
        vm.hoy = year + '-' + (month > 9 ? month: "0"+month)  + '-' + (day > 9 ? day: "0"+day);//'2024-05-21'
        vm.hojafabricacionactiva =[];
        vm.idhojafabricacionactiva = 0;
        vm.material_id = '';
        vm.material_id_a_forzar = '';
        vm.num_orden = "";
        vm.kits_a_preparar = 1;
        vm.filtroestado = "";
        vm.filtrodireccion = "ASC";
        vm.filtroorden = "";
        vm.toastclass='';
        vm.toastshow=false;
        vm.toastMsg = "";
        vm.materiales_fabricacion = [];
        vm.materiales_fabricacion_idirectos_parsed = [];
        vm.have_costes_fabricacion_indirectos = false;
        vm.fecha_caducidad_forzada = '';
        vm.generalLab = GenerallabService;
        vm.fecha_fabricacion = '';
        vm.spinneractivo = true;
        vm.tipoHoja = '';
        vm.hojaAccion = {accion:""};
        vm.acciones = {expanded:true};
        vm.pais_id = 5207332;// españa, al menos por ahora.

        vm.popupAcciones = "";
        vm.btnAcciones = function(){
          console.log("BTNACCIONES");
           vm.popupAcciones = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              //windowClass: 'modal-danger',
              //backdrop  : 'static',
              templateUrl: '/backend/hojafabricacion/template?name=acciones.twig',
              size: 'lg',
              controller: function($scope) {
                $scope.fabricacionid = vm.hojafabricacionactiva.id;
                $scope.acciones = vm.hojafabricacionactiva.acciones;
                $scope.hojafabricacionactiva = vm.hojafabricacionactiva;
                console.log("acciones1",vm.hojafabricacionactiva.acciones);
                $scope.okForm = function(){
                   vm.popupAcciones.close();
                   vm.getHojaFabricacion();
                }
                $scope.koForm = function(){
                    vm.popupAcciones.close();
                    vm.getHojaFabricacion();
                }
              }
            });
        }
        
        vm.showtoast = function(msg) {
            vm.toastMsg = msg;
            vm.toastclass = 'show';
            $timeout(function(){ 
                vm.toastclass = 'invisible';
                vm.toastMsg = '';
            }, 3000);
        }

        vm.cerrarInforme = function(data){
            $scope.$emit("cerrarPopup",data);
        }
        vm.marcarRevision = function(hoja_id){
            console.log('marcarRevision hoja_id?', hoja_id);
            vm.idhojafabricacionactiva = hoja_id;
            vm.modalEnvioAlic = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                templateUrl: '/backend/hojafabricacion/revisarhoja?hoja_fabricacion_id='+hoja_id+'&popup=true&tab=1',
                size: 'full',
                backdrop:'static',
                controller: function($scope) {
                    $scope.hj = vm;
                    $scope.okForm = function(){
                        vm.modalEnvioAlic.close();
                    }
                    $scope.$on("cerrarPopup", function(evt,data){ 
                        vm.modalEnvioAlic.close();
                    });
                    $scope.koForm = function(){
                        vm.modalEnvioAlic.close();
                    };

                }
            });
            
        }

        vm.parsaHojaFabricacion = function () {
            if (angular.isDefined(vm.hojafabricacionactiva.lineashoja) && typeof vm.hojafabricacionactiva.lineashoja === "object") {        
                Object.keys(vm.hojafabricacionactiva.lineashoja).forEach(function (key) {
                    let lineaHoja = vm.hojafabricacionactiva.lineashoja[key];
        
                    if (angular.isDefined(lineaHoja.stocks) && angular.isArray(lineaHoja.stocks)) {
                        lineaHoja.stocks.forEach(function (stock) {
                            if (!angular.isDefined(stock.unidades_utilizadas)) {
                                stock.unidades_utilizadas = stock.unidades_necesarias * vm.hojafabricacionactiva.unidades;
        
                                if (stock.composicion != stock.unidades_utilizadas) {
                                    stock.unidades_utilizadas = stock.composicion;
                                }
                            }
                        });
                    }
                });
            }
            
        }

        vm.agregarAccion = function() {
            console.log('agregar accion', vm.hojaAccion);
            if (vm.hojaAccion?.accion && vm.hojaAccion?.accion != '') {
                // vm.showtoast('Numero valido para seteaar');
                // console.log('Numero valido para seteaar')
            } else  {
                vm.showtoast('La acción debe tener texto.');
              return '';
            }
            var msgToast = 'Acción actualizada';
            var paramsToPost= {...vm.hojaAccion,...{hojafabricacion_id:vm.hojafabricacionactiva.id}};
            HojaService.setHojaFabricacionAccion(paramsToPost,function(data){
                console.log('data tras setHojaFabricacionAccion', data)
                if (!angular.isDefined(data.error) || !data.error) {
                    vm.pedidosActivos = [];
                    vm.showtoast('Acción asignada')
                } else {
                    vm.showtoast(data.error)
                }
                vm.hojafabricacionactiva.acciones = data.accioneshojafabricacion;
                vm.hojaAccion.accion = ''
            });
            
        }











        /*Nueva vista (Edu)*/
        vm.filtrosH = { material_id: '', pais_id: '', kits_a_preparar:0, tipohoja_id:'' };
        vm.metodo_generacion_lote = 'estandar';
        vm.hojaFabricacion = { materialesHoja : [], materialesIndirectos : [], lote_referencia : '', fecha_caducidad : null, fecha_fabricacion : null, observaciones : '', lote_fabricacion: '' };

        vm.validacionesEstado = {
            tecnico: false,
            calidad: false,
            almacen: false,
            supply: false
        };

        vm.flujos = [];

        vm.getMaterialPreparacion = function(){
            HojaService.getMaterialesPreparacion(vm.filtrosH,function(data){
                console.log("materiales recibidos",data);
                vm.hojaFabricacion.materialesHoja = data.materiales_fabricacion;
                vm.hojaFabricacion.materialesIndirectos = data.materiales_fabricacion_indirectos;
                vm.hojaFabricacion.lote_referencia = data.lote_referencia;
                vm.hojaFabricacion.lote_fabricacion = vm.hojaFabricacion.lote_referencia ? vm.hojaFabricacion.lote_referencia.lote : '';
                vm.getFechaCaducidad();
                console.log("data",vm.hojaFabricacion.materialesHoja);
            })

        }
        vm.getFechaCaducidad = function(){
            var date = '';
            for(var cont=0;cont<vm.hojaFabricacion.materialesHoja.length;cont++){
                if(angular.isDefined(vm.hojaFabricacion.materialesHoja[cont].stocks)){
                    for(var stockCount=0;stockCount<vm.hojaFabricacion.materialesHoja[cont].stocks.length;stockCount++){
                        if(vm.hojaFabricacion.materialesHoja[cont].mismo_lote && vm.hojaFabricacion.materialesHoja[cont].stocks[stockCount].fecha_caducidad != null && (vm.hojaFabricacion.materialesHoja[cont].stocks[stockCount].fecha_caducidad<date || date == '')){
                            date = vm.hojaFabricacion.materialesHoja[cont].stocks[stockCount].fecha_caducidad;
                            console.log("ACTUALIZO FECHA DE CADUCIADAD", date);
                        }
                    }
                }
            }
            if(date != ''){
                var dateStr = date.split(" ")[0]; 
                var parts = dateStr.split('-');
                vm.hojaFabricacion.fecha_caducidad = new Date(parts[0], parts[1] - 1, parts[2]);
            }
        }

        vm.puedoCrearHoja = function(){
            if(!vm.hojaFabricacion.fecha_fabricacion){
                return false;
            }

            if(vm.hojaFabricacion.lote_fabricacion == ''){
                return false;
            }
            
            var res = true;
            for(var cont=0;cont<vm.hojaFabricacion.materialesHoja.length;cont++){
                var material_ok = vm.checkErroresMaterial(vm.hojaFabricacion.materialesHoja[cont]);
                if(!material_ok && res){
                    res = false;
                }
            }
            return res;
        }

        vm.checkErroresMaterial = function(material){
            material.errors = [];
            material.warnings = [];
            var stock_suficiente = vm.stockSuficiente(material);
            var composicion_exacta = vm.checkComposicionStocks(material);
            if(!composicion_exacta){
                material.errors.push("La suma de las unidades necesarias del total de lotes del material debe ser exactamente "+material.composicion+".");
            }

            if(material.cantidad <= 0){
                material.errors.push("Las unidades del material no pueden ser menor o igual a 0.");
                return false;
            }
            return stock_suficiente && composicion_exacta;
        }

        vm.stockSuficiente = function(material){
            if(!angular.isDefined(material.stocks) || !material.stocks){
                material.errors.push("Material sin lotes disponibles.");
                return false;
            }
            var res = true;
            for(var cont = 0;cont<material.stocks.length;cont++){
                if(material.stocks[cont].id == null || material.stocks[cont].id == '' || material.stocks[cont].id == undefined){
                    material.errors.push("Lote no seleccionado.");
                    res = false;
                }
                if(material.stocks[cont].composicion < 0){
                    res = false;
                    material.errors.push("El lote "+material.stocks[cont].lote+" tiene unidades necesarias negativas.");
                }
                if(material.stocks[cont].unidades_disponibles < material.stocks[cont].composicion){
                    res = false;
                    material.errors.push("El lote "+material.stocks[cont].lote+" no tiene suficientes unidades de stock disponibles.");
                }
                if(angular.isDefined(material.stocks[cont].lote_caducado) && material.stocks[cont].lote_caducado){
                    material.warnings.push("El lote "+material.stocks[cont].lote+" está caducado.");
                }
            }
            return res;
        }

        vm.checkComposicionStocks = function(material){
            var unidadades_necesarias_restantes = vm.getUnidadesNecesariasRestantes(material);
            return unidadades_necesarias_restantes == 0;
        }

        vm.getUnidadesNecesariasRestantes = function(material){
            if(!angular.isDefined(material.stocks) || !material.stocks){
                return -1;
            }
            var composicion_stocks = 0;
            for(var cont = 0;cont<material.stocks.length;cont++){
                var c = parseFloat(material.stocks[cont].composicion) || 0;
                composicion_stocks+=c;
            }
            return material.composicion - composicion_stocks;
        }

        vm.nuevoLoteFifo = function(material){
            console.log("creando nuevo lote FIFO", material);
            HojaService.nuevoLoteFifo(material,function(data){
                console.log("data nuevo lote", data);
                if(data.stock){
                    data.stock.composicion = 0;
                    var unidades_necesarias_restantes = vm.getUnidadesNecesariasRestantes(material);
                    if(unidades_necesarias_restantes > 0){
                        if(data.stock.unidades_disponibles >= unidades_necesarias_restantes){
                            data.stock.composicion = unidades_necesarias_restantes;
                        }else{
                            data.stock.composicion = data.stock.unidades_disponibles;
                        }
                    }
                    material.stocks.push(data.stock);
                }
                vm.getFechaCaducidad();
                console.log("añadido nuevo lote", material);
                vm.checkErroresMaterial(material);
            })
        }

        vm.deleteStockMaterial = function(material, stockIndex){
            console.log("eliminando stock", material, stockIndex);
            material.stocks.splice(stockIndex, 1);
            vm.checkErroresMaterial(material);
        }

        vm.getLote = function(material, stockIndex, stock_id){
            console.log("getting nuevo lote", material, stockIndex, stock_id);
            HojaService.getLote(stock_id, function(data){
                console.log("data get lote", data);
                if(data.code>0){
                    if(data.stock.unidades_disponibles >= material.composicion){
                        data.stock.composicion = material.composicion;
                    }else{
                        data.stock.composicion = 0;
                        if(data.stock.unidades_disponibles > 0){
                            data.stock.composicion = data.stock.unidades_disponibles;
                        }
                    }
                    material.stocks[stockIndex] = data.stock;
                    vm.getFechaCaducidad();
                }
                vm.checkErroresMaterial(material);
            })
        }

        vm.getLoteFifoAlmacen = function(material, stockIndex, stock){
            HojaService.getLoteFifoAlmacen(stock.material_id, stock.composicion, stock.almacen_id, function(data){
                console.log("data get lote", data);
                if(data.stock){
                    if(data.stock.unidades_disponibles >= material.composicion){
                        data.stock.composicion = material.composicion;
                    }else{
                        data.stock.composicion = 0;
                        if(data.stock.unidades_disponibles > 0){
                            data.stock.composicion = data.stock.unidades_disponibles;
                        }
                    }
                    material.stocks[stockIndex] = data.stock;
                    vm.getFechaCaducidad();
                }else{
                    material.stocks[stockIndex].id = 0;
                }
                vm.checkErroresMaterial(material);
            })
        }

        vm.autocompletarStock = function(material, stock){
            console.log("autocompletando stock", material, stock);
            if(stock.unidades_disponibles <= 0){
                stock.composicion = 0;
                return;
            }
            var unidades_necesarias_restantes = vm.getUnidadesNecesariasRestantes(material);
            console.log("unidades necesarias restantes", unidades_necesarias_restantes);
            if(unidades_necesarias_restantes == 0){
                if(stock.composicion > stock.unidades_disponibles){
                    stock.composicion = stock.unidades_disponibles;
                }
                return;
            }
            
            stock.composicion = parseFloat(stock.composicion) + unidades_necesarias_restantes;
            console.log("composicion stock actualizada",stock.composicion);
            if(stock.composicion > stock.unidades_disponibles){
                stock.composicion = stock.unidades_disponibles;
            }else if(stock.composicion < 0){
                stock.composicion = 0;
            }
            vm.checkErroresMaterial(material);
        }

        vm.getProximoLoteHoja = function(){
            HojaService.getProximoLoteHoja(vm.filtrosH.material_id, vm.filtrosH.pais_id,vm.metodo_generacion_lote,function(data){
                console.log("Lote generado", data);
                if(data){
                    vm.hojaFabricacion.lote_fabricacion = data.proximo_lote;
                    vm.limite_fabricacion_mes = data.limite_fabricacion_mes;
                }
            })
        }

        vm.getCaducidadHoja = function(){
            console.log("Calculando fecha de caducidad a partir de fecha de fabricacion", vm.hojaFabricacion.fecha_fabricacion);
            HojaService.getCaducidadHoja(vm.hojaFabricacion.fecha_fabricacion, function(data){
                if(data.code>0 && data.fecha_caducidad){
                    var parts = data.fecha_caducidad.split('-');
                    vm.hojaFabricacion.fecha_caducidad = new Date(parts[0], parts[1] - 1, parts[2]);
                }
            });
        }

        vm.popupGastoIndirecto = false;
        vm.addGastoIndirectoPopup = function(){
            console.log("añadiendo nuevo gasto indirecto");
            vm.popupGastoIndirecto = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                templateUrl: 'addGastoIndirecto.html',
                size: 'lg',
                controller: function($scope) {
                    $scope.hc = vm;
                    $scope.gasto = {
                        impacto_material_id: null,
                        tipo: 'Impacto por unidad Fabricada',
                        valor: 0
                    };

                    $scope.okForm = function(){
                        vm.popupGastoIndirecto.close($scope.gasto);
                    }
                    $scope.koForm = function(){
                        vm.popupGastoIndirecto.dismiss('cancel');
                    }
                }
            });

            vm.popupGastoIndirecto.result.then(function (gasto) {
                console.log('Gasto indirecto a añadir:', gasto, vm.filtrosH);
                HojaService.addGastoIndirecto(gasto, vm.filtrosH,function(data){
                    console.log("data add gasto indirecto", data);
                    if(data.gasto_indirecto){
                        vm.hojaFabricacion.materialesIndirectos.push(data.gasto_indirecto);
                    }
                });
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        }

        vm.addMaterial = function(){
            console.log("añadiendo nuevo material");
            vm.hojaFabricacion.materialesHoja.push({material_extra: true, cantidad:0, materialgasto_id: 0, referencia_elabroado: 0, mismo_lote: 0, composicion: 0, stocks: []});
        }

        vm.deleteMaterial = function(materialIndex, material){
            console.log("eliminando material", materialIndex);
            vm.hojaFabricacion.materialesHoja.splice(materialIndex, 1);
        }

        vm.getMaterialGasto = function(material){
            if(material.materialgasto_id){
                console.log("GETTING NUEVO MATERIAL GASTO", material);
                HojaService.getMaterial(material.materialgasto_id, function(data){
                    if(data.code>0){
                        material.materialgasto = data.material;
                        material.stocks = [];
                        vm.nuevoLoteFifo(material);
                    }
                })
            }
        }

        vm.calculateComposicion = function(material){
            console.log("calculando composicion", material, vm.filtrosH.kits_a_preparar);
            material.composicion = material.cantidad * vm.filtrosH.kits_a_preparar;
        }

        vm.generaHojaFabricacionNew = function(){
            console.log("CREANDO HOJA FABRICACION", vm.hojaFabricacion);
            HojaService.setHojaFabricacion(vm.hojaFabricacion,vm.filtrosH,function(data){
                if(data.code==10){
                    window.location = "/backend/hojafabricacion/revisarhoja?hoja_fabricacion_id=" + data.hojafabricacion_id;
                }else{
                    vm.puedoCrearHoja = true;
                }
            })
        }

        vm.finalizado = false;
        vm.cancelado = false;
        vm.existe_liberado = false;
        vm.rol_permitido = false;
        vm.loading = true;
        vm.getHojaFabricacion = function(){
            HojaService.getHojaFabricacion(vm.idhojafabricacionactiva,function(data){
                vm.hojafabricacionactiva = data.hojafabricacioncondatos;
                switch (vm.hojafabricacionactiva.datosdestado.nombre) {
                    case "Finalizado":
                        vm.finalizado = true;
                        vm.hojafabricacionactiva.cantidad_fabricada = data.hojafabricacioncondatos.unidades;
                        break;
                    case "Cancelado":
                        vm.cancelado = true;
                        break;
                    default:
                        if(vm.hojafabricacionactiva.unidades > 0){
                            vm.hojafabricacionactiva.cantidad_fabricada = vm.hojafabricacionactiva.unidades;
                        }else{
                            vm.hojafabricacionactiva.cantidad_fabricada = vm.hojafabricacionactiva.unidades_previstas;
                        }
                        break;
                }

                vm.categoriasvalidacion = data.categoriasvalidacion;
                vm.existe_liberado = data.stock_liberado;
                vm.liberacion_pendiente = data.liberacion_pendiente;
                if(data.user_role == "admin"){
                    vm.rol_permitido = true;
                }
                vm.loading = false;
               console.log("HOJA FABRICACION ACTIVA",vm.hojafabricacionactiva);
            })
        }

        vm.puedoFinalizarHoja = function(){
            console.log("puedoFinalizarHoja", vm.hojafabricacionactiva);
            if(vm.hojafabricacionactiva.cantidad_fabricada == '' || vm.hojafabricacionactiva.cantidad_fabricada == 'null' || vm.hojafabricacionactiva.cantidad_fabricada <= 0){
                return false;
            }

            var res = true;
            Object.entries(vm.hojafabricacionactiva.lineashoja).forEach(function([key, material]) {
                material.errors = [];
                material.warnings = [];
                if (Array.isArray(material.stocks)) {
                    if(material.stocks.length <= 0){    
                        res = false;
                        material.errors.push("Linea sin lotes asignados.");
                    } else{
                        material.stocks.forEach(function(linea) {
                            if (linea.unidades_utilizadas === undefined || linea.unidades_utilizadas == '' || linea.unidades_utilizadas < 0) {
                                material.warnings.push("Lote "+linea.lote+" sin unidades usadas en la fabricación");
                            }
    
                            if(angular.isDefined(linea.stock_seleccionado.caducado) && linea.stock_seleccionado.caducado){
                                material.warnings.push("El lote "+linea.lote+" está caducado.");
                            }
    
                            if (linea.unidades_utilizadas > linea.stock_seleccionado.unidades_disponibles) {
                                material.errors.push("El lote "+linea.lote+" no tiene suficientes unidades de stock disponibles. Unidades disponibles: " + linea.stock_seleccionado.unidades_disponibles);
                                res = false;
                            }
    
                            if (!linea.stock_seleccionado.id) {
                                material.errors.push("Linea sin lote asignado.");
                                res = false;
                            }
                        });
                    }
                }
            });


            return res;
        }
        

        vm.addMaterialFinalizar = function(){
            console.log("añadiendo material finalizar hoja");
            const tempKey = 'temp'+ Date.now();
            vm.hojafabricacionactiva.lineashoja[tempKey] = {
                linea_extra: true,
                unidades_necesarias: 0,
                file: false,
                esacumulable: false,
                stocks: [],
            }
            vm.puedoFinalizarHoja();
        }

        vm.addLoteFinalizar = function(lineaExtra){
            console.log("adding nuevo lote finalizar hoja lineaExtra", lineaExtra);
            HojaService.nuevoLoteFifo(lineaExtra,function(data){
                console.log("data nuevo lote", data);
                console.log("hoja fabricacion activa", vm.hojafabricacionactiva);
                if(data.stock){
                    var lineaExtraStock = {
                        almacen_id: data.stock.almacen_id,
                        caducidad: data.stock.fecha_caducidad,
                        hojafabricacion_id:vm.hojafabricacionactiva.id,
                        id:'',
                        lineahojafabricacionid: '',
                        linea_referencia: false,
                        lote: data.stock.lote,
                        stockmaterial_id:data.stock.id,
                        productoausar:{},
                        stock_seleccionado:data.stock,
                        lang_id:1,
                        material_id:lineaExtra.materialgasto_id,
                        unidades_necesarias:0,
                        unidades_utilizadas:0,
                        composicion:0,
                        mermas: 0
                    }
                    lineaExtra.stocks.push(lineaExtraStock);
                }
                vm.puedoFinalizarHoja();
            })
        }

        vm.calculateUnidadesUtilizadasFinalizar = function(lineaExtra){
            console.log("Calculando unidades utilizadas", lineaExtra);
            if(angular.isDefined(lineaExtra.unidades_necesarias) && lineaExtra.unidades_necesarias > 0){
                lineaExtra.stocks[0].unidades_utilizadas = lineaExtra.unidades_necesarias * vm.hojafabricacionactiva.cantidad_fabricada;
            }
        }

        vm.calcularUnidadesUtilizadas = function(){
            console.log("Calculando unidades utilizadas", vm.hojafabricacionactiva.cantidad_fabricada, vm.hojafabricacionactiva.lineashoja);
            if (angular.isDefined(vm.hojafabricacionactiva.lineashoja) && typeof vm.hojafabricacionactiva.lineashoja === "object") {        
                Object.keys(vm.hojafabricacionactiva.lineashoja).forEach(function (key) {
                    let lineaHoja = vm.hojafabricacionactiva.lineashoja[key];
        
                    if (angular.isDefined(lineaHoja.stocks) && angular.isArray(lineaHoja.stocks)) {
                        lineaHoja.stocks.forEach(function (stock) {
                            stock.unidades_utilizadas = stock.linea_referencia.unidades_necesarias * vm.hojafabricacionactiva.cantidad_fabricada;
                        });
                    }
                });
            }
        }

        vm.maslotesFinalizarFabricacion = function(linea) {
            var copylinea = angular.copy(linea);
            var linaDuplicada = {
                duplicada:true,
                almacen_id: '',
                lote: '',
                hojafabricacion_id:copylinea.stocks[0].hojafabricacion_id,
                productoausar:copylinea.stocks[0].productoausar,
                stock_seleccionado:{unidades_utilizadas: 0},
                lang_id:copylinea.stocks[0].lang_id,
                material_id:copylinea.stocks[0].material_id,
                unidades_necesarias:0,
                unidades_utilizadas:0,
                id:'',
                mermas: 0,
                linea_referencia: false,
                composicion: 0,
                lineahojafabricacionid: ''
            }
            linea.stocks.push(linaDuplicada);
            console.log('Linea NEW', linea)
            vm.parsaHojaFabricacion();
            vm.puedoFinalizarHoja();
        }

        vm.validacionesFinalizadas = function(){
            var res = true;
            for(var cont=0;cont<vm.categoriasvalidacion.length && res;cont++){
                if(vm.categoriasvalidacion[cont].tiene_validacion){
                    res = vm.categoriasvalidacion[cont].validada;
                }
            }
            return res;
        }


        vm.removeLineaDuplicada = function(linea, stock) {
            console.log("removeLineaDuplicada",linea, stock);
            HojaService.removeLineaDuplicada(stock.id, function(data){
                if(data.code == 1){
                    let index = linea.stocks.findIndex(function(item) {
                        return item === stock;
                    });
                    if (index !== -1) {
                        linea.stocks.splice(index, 1);
                    } else {
                        console.log("El stock no se encontró en el array");
                    }
                }
            });        
        };

        vm.removeLineaFinalizar = function(key){
            console.log("removeLineaFinalizar", key);
            delete vm.hojafabricacionactiva.lineashoja[key];
            vm.puedoFinalizarHoja();
        }

        vm.removeStockDuplicado = function(linea, stockIndex){
            console.log("remove stock duplicado",linea, stockIndex);
            linea.stocks.splice(stockIndex, 1);
            vm.puedoFinalizarHoja();
        }


        vm.obtenerStockSeleccionadoLineaFabricacion = function (linea) {
            console.log("obtenerStockSeleccionadoLineaFabricacion",linea);
            HojaService.getStockSeleccionadoLinea(linea,0,1,function(data){
                if (angular.isDefined(data.skip)
                    && data.skip){
                        console.log("skip datos Linea")
                        return false;
                }
                console.log("return from obtenerStockSeleccionadoLineaFabricacion",data);
                linea.stock_seleccionado = data;

                linea.almacen_id =  linea.stock_seleccionado.almacen_id;
                linea.caducidad = linea.stock_seleccionado.fecha_caducidad;
                linea.lote = linea.stock_seleccionado.lote;
                linea.stockmaterial_id = linea.stock_seleccionado.id;
                vm.puedoFinalizarHoja();
                vm.parsaHojaFabricacion();
            })
        }

        vm.cambiarLoteLineaFabricacion = function(linea){
            console.log("cambiarLoteLineaFabricacion",linea);
            HojaService.cambiarLoteLineaFabricacion(linea,function(data){
                console.log("cambiarLoteLineaFabricacion return",data);
                if(data.code==1){
                    linea.almacen = data.almacen;
                    linea.caducidad = data.linea.caducidad;
                    linea.lote = data.linea.lote;
                    linea.stockmaterial_id = data.linea.stockmaterial_id;
                    linea.stock_seleccionado.can_be_use = data.stock_seleccionado.can_be_use;
                    linea.stock_seleccionado.errors = data.stock_seleccionado.errors;
                    linea.id = data.linea.id;
                }
                if(data.code==-2){
                    linea.stock_seleccionado.can_be_use = data.stock_seleccionado.can_be_use;
                    linea.stock_seleccionado.errors = data.stock_seleccionado.errors;
                    console.log("linea con algun error", linea);
                }
            });
        }

        vm.guardarFabricacion = function(){
            vm.hojafabricacionactiva.unidades = vm.hojafabricacionactiva.cantidad_fabricada;
            console.log('Lo que envio GUARDAR FABRICACION',vm.hojafabricacionactiva)
            HojaService.guardarFabricacion(vm.hojafabricacionactiva, function(data){
                console.log("guardarFabricacion return",data);
                if(data.code < 0){
                    vm.hojafabricacionactiva.lineashoja = data.lineashoja;
                    return false;
                }
                vm.getHojaFabricacion();
            });
        }
      

        vm.finalizarFabricacion = function(){
            vm.hojafabricacionactiva.unidades = vm.hojafabricacionactiva.cantidad_fabricada;
            console.log('Lo que envio GUARDAR FABRICACION',vm.hojafabricacionactiva)
            HojaService.guardarFabricacion(vm.hojafabricacionactiva, function(data){
                console.log("guardarFabricacion return",data);
                if(data.code < 0){
                    vm.hojafabricacionactiva.lineashoja = data.lineashoja;
                    return false;
                }
                console.log('Lo que envio FINALIZAR FABRICACION', vm.hojafabricacionactiva)
                HojaService.finalizarFabricacion(vm.hojafabricacionactiva,function(finalizarHojaFabricacionResult){
                    console.log("finalizarFabricacion return",finalizarHojaFabricacionResult);
                    if(finalizarHojaFabricacionResult.code>0){
                        vm.getHojaFabricacion();
                    }
                });
            })

        }
    }

})();
